export type SortDir = 'asc' | 'desc' | undefined | null;

export type Status = 'activos' | 'inactivos' | 'todos' | undefined | null;

export interface PaginationQueryParams {
  columnaFiltro: string;
  columnaOrden: string;
  direccionOrden: SortDir;
  filtro: string;
  pagina: number;
  limite: number;
}

export interface PaginationQueryParamsWithStatus {
  columnaFiltro: string;
  columnaOrden: string;
  direccionOrden: SortDir;
  filtro: string;
  pagina: number;
  limite: number;
  status?: Status;
}

export function toQueryString(params: PaginationQueryParams | PaginationQueryParamsWithStatus) {
  let { columnaFiltro, columnaOrden, direccionOrden, filtro, pagina, limite } = params;

  columnaFiltro ??= 'nombre';
  columnaOrden ??= 'clave';
  direccionOrden ??= 'asc';
  filtro ??= '';
  pagina ??= 0;
  limite ??= 10;

  let queryString =
    `columnaFiltro=${columnaFiltro}&columnnaOrden=${columnaOrden}&` +
    `direccionOrden=${direccionOrden}&filtro=${filtro}&pagina=${pagina}&limite=${limite}`;

  if ('status' in params) {
    queryString += `&status=${params.status}`;
  }

  return queryString;
}
